import get from "lodash/get"
import axios from "axios"
import {
  GET_GUEST_BULK_PICKUP_DATES_FAILED,
  GET_GUEST_BULK_PICKUP_DATES_FULFILLED,
  GET_GUEST_BULK_PICKUP_DATES_PENDING,
} from "constants-lib/actionTypes"
import dayjs from "utils-lib/date"
import URITemplate from "urijs/src/URITemplate"
import { urls } from "utils-lib/builds"

export const pendingAC = () => ({
  type: GET_GUEST_BULK_PICKUP_DATES_PENDING,
})

export const failedAC = () => ({
  type: GET_GUEST_BULK_PICKUP_DATES_FAILED,
})

export const fulfilledAC = (data) => ({
  type: GET_GUEST_BULK_PICKUP_DATES_FULFILLED,
  payload: data,
})

/**
 * Fetches bulk pickup dates for a guest user within a 60-day range from the current date.
 * @param {string} lang - The language code for the API request.
 * @param {string} customerId - The customer ID for which the bulk pickup dates are being requested.
 */
export const getGuestBulkPickupDates =
  (lang, customerId) => (dispatch, getState) => {
    dispatch(pendingAC())
    const api = `GUEST_BULK_PICKUP_DATES`
    const apiKey = get(urls, `apiKey.GUEST[${api}]`, ``)
    const state = getState()

    const template = URITemplate(urls.url[api])

    const url = template.expand({
      fromDate: dayjs().format(`YYYY-MM-DD`),
      toDate: dayjs().add(60, `days`).format(`YYYY-MM-DD`),
      customerId,
      eligibilityId: get(
        state,
        `customerSelections.cityBilledEligibility.eligibilityId`,
        ``,
      ),
      lang,
    })

    const config = {
      headers: {
        apiKey,
      },
    }
    return axios
      .create(config)
      .get(url)
      .then((response) => {
        dispatch(fulfilledAC(response.data))
        return response.data
      })
      .catch(() => {
        dispatch(failedAC())
      })
  }
